let googleMapsPromise;

const SCRIPT_ID = 'google-maps-script';

function loadGoogleMapsScript() {
  // API must be loaded only once per page, even after hot reload of this module
  if (window.google && window.google.maps && window.google.maps.importLibrary) {
    return Promise.resolve();
  }

  return new Promise((resolve, reject) => {
    const key = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;
    const existingScript = document.getElementById(SCRIPT_ID);
    const script = document.createElement('script');

    window.initGoogleMaps = () => resolve();

    if (existingScript) {
      return;
    }

    script.id = SCRIPT_ID;
    script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&v=weekly&loading=async&callback=initGoogleMaps`;
    script.async = true;
    script.onerror = () => {
      script.remove();
      reject();
    };

    document.head.appendChild(script);
  });
}

// Loads Google Maps JS API once and resolves with the classes used on the map
export function loadGoogleMaps() {
  if (!googleMapsPromise) {
    googleMapsPromise = loadGoogleMapsScript()
      .then(() => {
        const { maps } = window.google;

        return Promise.all([
          maps.importLibrary('maps'),
          maps.importLibrary('core'),
          maps.importLibrary('marker'),
        ]);
      })
      .then(([mapsLib, coreLib, markerLib]) => ({
        Map: mapsLib.Map,
        LatLngBounds: coreLib.LatLngBounds,
        ControlPosition: coreLib.ControlPosition,
        AdvancedMarkerElement: markerLib.AdvancedMarkerElement,
      }))
      .catch(() => {
        googleMapsPromise = null;
        return Promise.reject();
      });
  }

  return googleMapsPromise;
}

export function getGoogleMapId() {
  return process.env.REACT_APP_GOOGLE_MAP_ID;
}
